export const LOADING_SCREEN_DURATION = 30000; // 30 seconds

export const PROCESSING_STEPS = [
  'Analyzing image...',
  'Extracting license plate information...',
  'Validating data...',
  'Preparing report...'
];

export const US_STATES = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
  'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
  'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
  'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
  'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'
];

export const VIOLATION_REASONS = [
  {
    value: 'blocking_driveway',
    label: 'Blocking a Driveway or Sidewalk',
    description: 'Includes private driveways, sidewalks, and crosswalks'
  },
  {
    value: 'blocking_fire_hydrant',
    label: 'Blocking a Fire Hydrant or Bus Stop',
    description: ''
  },
  {
    value: 'double_parked',
    label: 'Double Parked Vehicle',
    description: ''
  },
  {
    value: 'commercial_overnight',
    label: 'Commercial Vehicle Parked Overnight',
    description: ''
  },
  {
    value: 'abandoned_vehicle',
    label: 'Abandoned or Unattended Vehicle',
    description: 'Includes cars left in one spot over 7 days, visibly abandoned vehicles'
  },
  {
    value: 'handicap_zone',
    label: 'Illegally Parked in Handicap Zone',
    description: ''
  },
  {
    value: 'street_signs',
    label: 'Parked in Violation of Street Signs',
    description: 'e.g., No Standing, Street Cleaning, Loading Zones'
  },
  {
    value: 'suspicious_plate',
    label: 'Suspicious or Fake License Plate',
    description: 'Includes paper plates, covered or unreadable plates'
  },
  {
    value: 'government_placard',
    label: 'Illegally Parked Government or Placard Vehicle',
    description: ''
  },
  {
    value: 'other',
    label: 'Other (Please Specify)',
    description: 'Free-text field opens if selected'
  }
]; 